import gql from 'graphql-tag'

export const fragment = gql`
fragment getClosingFragment on Closing {
	id
	number
	dateTime
	total
	cashRegisterId

	clientCount
	productCount
  cancellationsCount
  clientCardValue

  billNumStart
  billNumEnd
  moneyCountDateTime
  doorCounter
  guestsCount

  inactive
  inactiveDate
  inactiveReason
  inactiveUserId

  dateInterval {
		from
		to
	}
  salesGroups {
		id
		amount
		total
		mWStNormal
		mWStReduced
		mWStFree
    mWStSpecial
		discount
		reduction
		salesGroup {
			id
			name
			acountNum
		}
	}
	currency {
		name
		present
		exchangeRate
		presentConverted
		difference
		cashInTransit
		amount
		amountConverted
	}
  taxes {
    MWSt
    sales
    total
    percent
  }
  paymentMethods {
    name
    count
    amount
  }
  coupons {
  	name
  	amount
  }
  cashbook(groupCashbooksBy: DESCRIPTION) {
    description
    have
    should
  }
  specialSales {
  	name
  	amount
  }
  users {
    id
    user {
    	id
      name
      code
    }
    total
    clientCount
    averageBill
    userEfficiency
    cancellationsCount
    cancellationsAmount
    buttonOpenCount
    buttonBackCount
    buttonDelCount
    buttonDelAmount
    inCafeCount
    inCafeAmount
    inCafePercent
    tipsTotal
  }
  priceDifference {
		id
		mod_ver
		product {
      id
      name
      code
    }
		type
		quantity
		reduction
  }
  creditClientOrders {
  	id
    invoiceId
    total
    creditClient {
      id
      clientNumber
      name
    }
    cashRegister {
      id
      name
    }
    items {
      id
      price
      amount
      total
      product {
        id
        name
        code
      }
    }
  }
}
`

const query = gql`
query getClosing($id: ID!) {
	cashAssist {
		getClosing(id: $id) {
			...getClosingFragment
		}
	}
}
${fragment}
`

export default query

// dateTime
// id
// code
// mod_ver
// total
// cashRegister {
//   id
//   name
// }
// data {
//   statistics {
//     salesPerProduct
//   }
//   CHF {
//     amount
//   }
//   Euro {
//     amount
//   }
//   MWSt {
//     MWSt
//     MWStRate
//     MWStSumm
//   }
// }
// salesGroups {
//   id
//   total
//   amount
//   salesGroup {
//     id
//     mod_ver
//     acountNum
//     name
//   }
// }
